import React, { useMemo } from 'react';
import {
    CollegeCompliments,
    CollegeGreetings,
    CollegeQuestions,
    CollegeResponses,
    GeneralMessages,
    HighSchoolGreetings,
    HighSchoolQuestions,
    HighSchoolResponses,
    ParentGreetings,
    PlayerGreetings,
    PlayerQuestions,
    PlayerResponses,
} from '../../../client/MessageOptions';
import { AppStateUser } from '../../../client/providers/AppProvider';
import { Espin_Role_Enum } from '../../../generated/spin-graphql';
import { ResponseType } from './ConversationNavigation';

type Props = {
    user: AppStateUser;
    conversantName: string;
    responseType: ResponseType;
    setSelectedMessage: (message: string) => void;
};

export const ResponseSelector: React.FC<Props> = ({ user, conversantName, responseType, setSelectedMessage }) => {
    const options = useMemo(() => {
        switch (responseType) {
            case ResponseType.GREETINGS: {
                if (user.role === Espin_Role_Enum.EspinPlayerUser) {
                    return PlayerGreetings;
                }
                if (user.role === Espin_Role_Enum.EspinParentUser) {
                    return ParentGreetings;
                }
                if (user.role === Espin_Role_Enum.EspinCollegeUser) {
                    return CollegeGreetings;
                }
                if (user.role === Espin_Role_Enum.EspinHighschoolUser) {
                    return HighSchoolGreetings;
                }
            }
            case ResponseType.GENERAL: {
                return GeneralMessages;
            }
            case ResponseType.COMPLIMENTS: {
                if (user.role === Espin_Role_Enum.EspinCollegeUser) {
                    return CollegeCompliments;
                }
            }
            case ResponseType.QUESTIONS: {
                if (user.role === Espin_Role_Enum.EspinPlayerUser || user.role === Espin_Role_Enum.EspinParentUser) {
                    return PlayerQuestions;
                }
                if (user.role === Espin_Role_Enum.EspinCollegeUser) {
                    return CollegeQuestions;
                }
                if (user.role === Espin_Role_Enum.EspinHighschoolUser) {
                    return HighSchoolQuestions;
                }
            }
            case ResponseType.RESPONSES: {
                if (user.role === Espin_Role_Enum.EspinPlayerUser || user.role === Espin_Role_Enum.EspinParentUser) {
                    return PlayerResponses;
                }
                if (user.role === Espin_Role_Enum.EspinCollegeUser) {
                    return CollegeResponses;
                }
                if (user.role === Espin_Role_Enum.EspinHighschoolUser) {
                    return HighSchoolResponses;
                }
            }
            default:
                return GeneralMessages;
        }
    }, [user, responseType]);

    return (
        <div className={`response-selector ${responseType}`}>
            <div className="content">
                {options.map((option, index) => {
                    option = option.replaceAll('{conversantName}', conversantName);

                    return (
                        <button
                            className="button response-button"
                            key={`response-button-${index}`}
                            onClick={() => setSelectedMessage(option)}
                        >
                            {option}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
